<div class="backdrop">
  <div class="pic"></div>
  <div class="form">
    <form class="reset-password-form" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
      <h1 class="headline-large">Reset password</h1>

      <app-text-field
        label="Password"
        formControlName="password"
        [inputType]="inputType"
        [hasEye]="true"
        (revealOrHide)="onRevealOrHide($event)"
      ></app-text-field>

      <app-text-field
        label="Confirmed Password"
        formControlName="confirmedPassword"
        [inputType]="inputTypePassCopy"
        [hasEye]="true"
        (revealOrHide)="onRevealOrHideCopy($event)"
      ></app-text-field>

      <mat-error *ngIf="formGroup.touched && formGroup.hasError('passwordMismatch')">Password and Confirm Password do not match.</mat-error>
      <mat-error *ngIf="formGroup.get('password').touched && formGroup.get('password').hasError('passwordLength')">
        Password must be at least 15 characters long.
      </mat-error>

      <button
        mat-flat-button
        aria-label="Reset Password"
        class="buttons"
        type="submit"
        color="primary"
        [isBusy]="isBusy"
        tabindex="0"
        [disabled]="!formGroup.valid"
      >
        Submit
      </button>
      <a class="back-to-login" [routerLink]="loginUrl">Back to login</a>

      <p class="mt-4">
        <b>Password requirements</b><br />
        <small> A minimum of 15 characters </small>
      </p>
    </form>
  </div>
</div>
